import {
  GraphicMediaData,
  GraphicData,
  GraphicNodeData,
  MediaData,
} from '../../../types/quiz';
import { getQuestion, parseMainExp, parseStringWithNode } from './utils';

/**
 * GraphicData.
 */
export const mapGraphicData = ({
  data,
  mediaData,
}: {
  data: GraphicNodeData;
  mediaData: MediaData<GraphicMediaData[]>;
}): GraphicData => {
  return {
    question: getQuestion<GraphicMediaData[]>(data.q, mediaData),
    answerOrder: Number.parseInt(data.ao, 10),
    mainExplanation: parseMainExp<GraphicMediaData[]>(data.e, mediaData) || '',
    keyTakeaway: parseMainExp<GraphicMediaData[]>(data.kp, mediaData) || '',
    answers: data.a.map((a) => {
      const answerText = a.v.s ?? a.v;
      return {
        explanation: a.e || '',
        text: parseStringWithNode(answerText, mediaData),
        isCorrect: a.c === '1',
      };
    }),
  };
};
